exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "button-busy-indicator {\n  display: inline-block;\n  position: relative;\n  width: 16px;\n  height: 15px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/forms/buttonBusyIndicator/buttonBusyIndicator.component.less
// module id = 2436
// module chunks = 0